import React from "react";
import Experience from "../components/Experience";

function ExperiencePage() {
  return <Experience />;
}

export default ExperiencePage;